export default __webpack_public_path__ + "static/media/express.9732b745.png";